<div class="title">
  <h3>Fulfillment ready</h3>

  <!-- TODO swtich dropdown to popovers -->
  <pdq-dropdown
    mode="ghost"
    placeholder="Filter carriers"
    [options]="carriers?.options"
    (onChange)="setBatchFilter(FilterBy.CARRIERS, $event)"></pdq-dropdown>
  <pdq-dropdown
    mode="ghost"
    placeholder="Filter location"
    [options]="locations?.options"
    (onChange)="setBatchFilter(FilterBy.LOCATIONS, $event)"></pdq-dropdown>

  <pdq-button
    pdqPopover
    closeOnPopoverClick
    [popoverTemplate]="userCollaborationRef"
    [active]="owners.active"
    (onClick)="owners.active = true"
    variant="ghost"
    secondaryIcon="large_toggle_arrow"
    ><span style="color: var(--on-surface-light)">{{ owners.displayName }}</span></pdq-button
  >
  <!-- temp span color -->
  <ng-template #userCollaborationRef>
    <pdq-popover-container [loading]="false">
      <pdq-options-list
        [options]="owners.options"
        (onChange)="setBatchFilter(FilterBy.OWNERS, $event); owners.displayName = $event.label"
        (onDestroy)="owners.active = false">
      </pdq-options-list>
    </pdq-popover-container>
  </ng-template>
</div>

@if (batches.length) {
  <div class="columns">
    @for (column of columns; track $index) {
      <div class="column">
        {{ column }}
      </div>
    }
  </div>
}
<div class="rows-wrapper" cdkDropList [cdkDropListData]="batches" (cdkDropListDropped)="onDroped($event)">
  <div *ngIf="filteredBatches?.length === 0 && hasActiveFilters" class="no-batch-message">
    No batch found for selected filters.
  </div>
  <cdk-virtual-scroll-viewport [style.height.px]="400" itemSize="80">
    <div *cdkVirtualFor="let batch of filteredBatches; trackBy: trackByFn" cdkDrag>
      <fulfill-batch-list-table-row [batch]="batch" state="fulfillmentReady"></fulfill-batch-list-table-row></div
  ></cdk-virtual-scroll-viewport>
</div>
